import { Fragment } from "react";
import { Check, X } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ADVANTAGES = [
  "New on Green Street, 2026",
  "Curated Bridal Jewellery",
  "Fresh Pieces Every Week",
  "Fast UK Royal Mail Tracked",
];

const GOLD =
  "linear-gradient(160deg, #f8e9b0 0%, #edd28c 22%, #ddbc67 52%, #edd28c 80%, #f9edb8 100%)";

export const WhyZebaa = () => (
  <section
    className="bg-white pt-6 pb-8 lg:pt-10 lg:pb-14"
    data-testid="why-zebaa-section"
    aria-labelledby="why-zebaa-heading"
  >
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center mb-8 sm:mb-12">
        <h2
          id="why-zebaa-heading"
          aria-label="Why Zebaa?"
          className="font-serif text-3xl sm:text-4xl lg:text-5xl text-charcoal flex items-center justify-center gap-2 sm:gap-3"
        >
          <span aria-hidden>Why</span>
          <span
            aria-label="Zebaa"
            className="font-serif tracking-[0.14em] text-3xl sm:text-4xl lg:text-5xl"
            style={{ color: "var(--pink)" }}
          >
            Zebaa
          </span>
          <span aria-hidden className="-ml-1">?</span>
        </h2>
        <p className="text-xs sm:text-sm text-gray-400 mt-3 tracking-wide">
          Green Street's newest South Asian imitation jewellery shop.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <div
          className="relative mx-auto max-w-3xl grid grid-cols-[1fr_78px_58px] sm:grid-cols-[1fr_210px_160px]"
          data-testid="why-comparison"
        >
          {/* Floating gold column */}
          <div
            className="z-10 rounded-3xl my-[-14px] sm:my-[-22px]"
            style={{
              gridColumn: 2,
              gridRow: "1 / span 5",
              background: GOLD,
              boxShadow: "0 28px 60px -22px rgba(190,150,50,0.55), 0 0 42px rgba(236,207,128,0.4)",
            }}
            data-testid="why-gold-card"
            aria-hidden
          />

          {/* Header row */}
          <div style={{ gridColumn: 2, gridRow: 1 }} className="z-20 h-20 sm:h-24 flex items-center justify-center px-2">
            <span
              aria-label="Zebaa"
              className="font-serif tracking-[0.14em] text-lg sm:text-xl"
              style={{ color: "#111111" }}
            >
              Zebaa
            </span>
          </div>
          <div style={{ gridColumn: 3, gridRow: 1 }} className="z-20 h-20 sm:h-24 flex items-center justify-center">
            <span className="text-sm sm:text-xl text-gray-400 tracking-wide">Others</span>
          </div>

          {/* Comparison rows */}
          {ADVANTAGES.map((label, i) => (
            <Fragment key={label}>
              <div
                style={{ gridColumn: 1, gridRow: i + 2 }}
                className="z-20 min-h-[72px] sm:min-h-[88px] flex items-center pr-3 sm:pr-5 border-t border-gray-200 text-charcoal text-sm sm:text-lg leading-snug"
                data-testid={`why-row-${i}`}
              >
                {label}
              </div>
              <div style={{ gridColumn: 2, gridRow: i + 2 }} className="z-20 flex items-center justify-center">
                <Check className="w-5 h-5 sm:w-6 sm:h-6 text-[#4a3808]" strokeWidth={3} />
              </div>
              <div
                style={{ gridColumn: 3, gridRow: i + 2 }}
                className="z-20 flex items-center justify-center border-t border-gray-200"
              >
                <X className="w-5 h-5 sm:w-6 sm:h-6 text-gray-300" strokeWidth={2.5} />
              </div>
            </Fragment>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
